// extracted by mini-css-extract-plugin
export default {"Box":"title-renderer-module__Box--pwWiB","Box_1":"title-renderer-module__Box_1--Ns49D","Text":"title-renderer-module__Text--zBNKh"};